import React, { Component } from 'react';
import BackendService from '../BackendService.js';
import _ from 'lodash';

import { connect } from 'react-redux';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal'

import CustomTable from '../CustomTable/CustomTable';
import FormBenutzer from './FormBenutzer'
import Button from 'react-bootstrap/Button';

class ViewBenutzer extends Component {

    constructor() {
        super();
        this.state = {
            data: [],
            selectedUser: {},
            creatingNew: false
        }
        BackendService.getUsers().then(
            users => {
                users.map(user => user.key = user.benutzer_id)
                this.setState({
                    data: users
                })
            }
        )

        this.columns = [
            {
                title: 'Benutzer',
                key: 'nachname',
                cell: row => <span key={row.key}>{row.nachname + ', ' + row.vorname}</span>,
                sortable: true
            }
        ]

        this.onNew = this.onNew.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onDelete = this.onDelete.bind(this);

    }

    handleChange = e => {
        let key = e.target.id;
        let value = e.target.value
        console.log(key + ': ' + value)
        this.setState(prevState => ({
            selectedUser: {
                ...prevState.VA,
                [key]: value
            }
        }))
    };

    onNew(user) {
        user.key = user.benutzer_id
        let data = _.cloneDeep(this.state.data)
        data.push(user)
        this.setState({ data })
    }

    onEdit(user) {
        user.key = user.benutzer_id
        let data = _.cloneDeep(this.state.data)
        data[_.findIndex(data, (u) => u.benutzer_id === user.benutzer_id)] = user
        this.setState({ data })
    }

    onDelete(userID) {
        let data = _.cloneDeep(this.state.data)
        data.splice(_.findIndex(data, (u) => u.benutzer_id === userID), 1)
        this.setState({ data })
    }

    render() {
        return (
            <div className={this.props.className}>
                <Container fluid>
                    <Row>
                        <Button onClick={() => { this.setState({ creatingNew: true }) }} disabled={this.props.rights[2]===undefined}>Neuer Benutzer</Button>
                    </Row>
                    <Row>
                        <Col xs={7}>
                            <CustomTable
                                title="Veranstaltungen"
                                collumns={this.columns}
                                data={this.state.data}
                                pagination
                                onSelect={(row) => {
                                    this.setState({
                                        selectedUser: _.cloneDeep(row)
                                    })
                                }}
                            />
                        </Col>
                        <Col xs={5}>
                            <FormBenutzer
                                selected={this.state.selectedUser}
                                onSubmit={this.onEdit}
                                onDelete={this.onDelete}
                            />
                        </Col>
                    </Row>
                </Container>
                <Modal
                    size="xl"
                    show={this.state.creatingNew}
                    centered
                    onHide={() => this.setState({ creatingNew: false })}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Neuer Benutzer
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FormBenutzer
                            new
                            selected={{}}
                            onSubmit={this.onNew}
                        />
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        rights: state.userData.rights,
    }
}

export default connect(mapStateToProps)(ViewBenutzer)